var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Página no encontrada")]),_c('p',{staticClass:"subtitle"},[_vm._v("Lo sentimos, la página que buscas no existe.")])])])
}]

export { render, staticRenderFns }